import styled from 'styled-components';
import background from '../../assets/images/section1Background.webp';
import background3 from '../../assets/images/section3Background.webp';
import background4 from '../../assets/images/section4Background.webp';
import { H1 } from '../../styles/FontStyles';
import { Div } from 'styles';

export const Section1Wrapper = styled.section`
  width: 100%;
  background-image: url(${background});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  /* min-height: 100vh; */
  padding: 200px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1000px) {
    padding: 150px 0;
  }
`;

export const Section2Wrapper = styled.section`
  width: 100%;
  /* background-image: url(${background}); */
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  /* min-height: 100vh; */
  padding: 150px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const GrayBoxWrapper = styled.div`
  padding: 20px;
  border-radius: 32px;
  background-color: ${({ theme }) => theme.gray};
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  width: 100%;

  > div {
    box-shadow: 0px 4.06px 28.63px 0px rgba(0, 0, 0, 0.25);
    background-color: ${({ theme }) => theme.white};
    border-radius: 32px;
  }

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
`;

export const GrayBoxWrapper2 = styled.div`
  padding: 20px;
  border-radius: 32px;
  background-color: ${({ theme }) => theme.gray};
  color: ${({ theme }) => theme.white};
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 16px;
  width: 100%;

  > div:nth-child(4) {
    background: linear-gradient(
      223.24deg,
      #ffb084 7.75%,
      #f02b00 48.79%,
      #2f092a 91.22%
    );
  }

  img {
    width: 100%;
  }

  > div {
    box-shadow: 0px 4.06px 28.63px 0px rgba(0, 0, 0, 0.25);
    background: linear-gradient(
        346.37deg,
        #131111 -0.25%,
        #160d0d 58.3%,
        #ff7051 106.2%
      ),
      linear-gradient(0deg, rgba(0, 0, 0, 0.27), rgba(0, 0, 0, 0.27));

    border-radius: 32px;
  }

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
`;

export const TextWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.primary};
  border-radius: 200px;
  padding: 8px 24px;
`;

export const Section4Wrapper = styled.section`
  width: 100%;
  background-image: url(${background4});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding-top: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Section3Wrapper = styled.section`
  width: 100%;
  background-image: url(${background3});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  /* min-height: 100vh; */
  padding: 120px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Section5Wrapper = styled.section`
  width: 100%;
  background-image: url(${background});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 0;
`;

export const Section1Image1 = styled.img`
  width: 100%;
  margin-bottom: 120px;
`;

export const Section1Image2 = styled.img`
  width: 100%;
`;

export const Section4Title = styled(H1)`
  span {
    background: linear-gradient(
      222.2deg,
      #ffb084 18.48%,
      #f02b00 52.72%,
      #ffffff 88.12%
    );

    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

export const Section3Boxes = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 16px;

  > {
    :nth-child(1) {
      background: linear-gradient(
        130deg,
        #131111 0%,
        #160d0d99 50%,
        #cc845099 100%
      );
    }

    :nth-child(2) {
      background: linear-gradient(
        130deg,
        #131111 0%,
        #160d0d99 50%,
        #e4cd7099 100%
      );
    }

    :nth-child(3) {
      background: linear-gradient(
        130deg,
        #131111 0%,
        #160d0d99 50%,
        #1a655b99 100%
      );
    }

    :nth-child(4) {
      background: linear-gradient(
        130deg,
        #131111 0%,
        #160d0d99 50%,
        #df9e8499 100%
      );
    }
  }

  > div {
    border: 0.5px solid ${({ theme }) => theme.gray}80;
    box-shadow: 0px 4.06px 28.63px 0px rgba(0, 0, 0, 0.25);

    overflow: hidden;
    border-radius: 32px;
    div > * {
      color: ${({ theme }) => theme.white};
    }
  }
  img {
    width: 100%;
  }

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
`;

export const Main = styled.div`
  max-width: 1600px;
  padding: 0 100px;
  width: 100%;
  margin: 0 auto;

  @media (max-width: 1000px) {
    padding: 0 30px;
  }
`;

export const Section5Text = styled.h2`
  /* font-family: 'instrumens'; */
  font-weight: 400;
  font-size: 180px;
  letter-spacing: -0.04em;
  line-height: 181.67px;
  text-align: center;
  color: ${({ theme }) => theme.white};
  margin: 0;

  font-family: FONTSPRING DEMO - Balgin;

  @media (max-width: 1000px) {
    font-size: 80px;
    line-height: 76.7px;
  }
`;

export const ProfileNavButton = styled.div<{ $selected: boolean }>`
  border: 1px solid
    ${({ theme, $selected }) => ($selected ? theme.white : theme.primary)};
  border-radius: 50%;
  width: 36px;
  height: 36px;
  background: #1b3b40;
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    opacity: ${({ $selected }) => ($selected ? '1' : '0.5')};
  }
`;
